import React from 'react';
import { ErrorBoundarySuspense } from '../../index';
var LazyGroupingMessages = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_notification-list/GroupingMessages" */
  './main');
});
export default function GroupingMessages() {
  return /*#__PURE__*/React.createElement(ErrorBoundarySuspense, {
    loadingFallback: /*#__PURE__*/React.createElement("div", null),
    errorFallback: /*#__PURE__*/React.createElement("div", null),
    subjectId: "grouping-messages-chunk"
  }, /*#__PURE__*/React.createElement(LazyGroupingMessages, null));
}